import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { AuthOnboardingLayout } from '../../components/login-v2/AuthShell';
import AuthBackHeader from '../../components/login-v2/AuthBackHeader';
import AuthMascot from '../../components/login-v2/AuthMascot';
import AuthPrimaryButton from '../../components/login-v2/AuthPrimaryButton';
import AuthSecondaryButton from '../../components/login-v2/AuthSecondaryButton';
import AuthTextField from '../../components/login-v2/AuthTextField';
import { AuthContext } from '../../context/AuthContext';
import { isSignupOnboarding } from './signupStorage';

function hasStoredAuth() {
  return Boolean(localStorage.getItem('accessToken') && localStorage.getItem('refreshToken'));
}

function resolveToken(accessToken) {
  if (accessToken) return accessToken;
  try {
    return JSON.parse(localStorage.getItem('accessToken') || 'null')?.value || null;
  } catch {
    return null;
  }
}

export default function LoginV2ReferralPage() {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken } = useContext(AuthContext);
  const accessToken = useAccessToken();

  const [code, setCode] = useState('');
  const [errorText, setErrorText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!accessToken && !hasStoredAuth()) {
      navigate('/login', { replace: true });
      return;
    }
    if (accessToken && !isSignupOnboarding()) {
      navigate('/playground', { replace: true });
    }
  }, [accessToken, navigate]);

  const goComplete = () => navigate('/login-v2/complete', { replace: true });

  const submitReferral = async () => {
    const refCode = code.trim();
    const token = resolveToken(accessToken);
    if (!refCode) {
      setErrorText('추천인 코드를 입력해주세요.');
      return;
    }
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    setSubmitting(true);
    setErrorText('');
    try {
      const response = await fetch(`${API_SERVER_DOMAIN}/user/ref/submit`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ref_code: refCode }),
      });
      const jsonData = await response.json();
      if (jsonData.result === 'ok') {
        goComplete();
      } else {
        setErrorText(jsonData.message || '존재하지 않는 추천인 코드예요.');
      }
    } catch (error) {
      console.error(error);
      setErrorText('네트워크 오류가 발생했어요. 다시 시도해 주세요.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthOnboardingLayout
      header={<AuthBackHeader onBack={() => navigate('/login-v2/nickname')} />}
      actions={
        <div className="flex flex-col gap-3">
          <AuthPrimaryButton disabled={!code.trim() || submitting} onClick={submitReferral}>
            등록하기
          </AuthPrimaryButton>
          <AuthSecondaryButton disabled={submitting} onClick={goComplete}>
            건너뛰기
          </AuthSecondaryButton>
        </div>
      }
    >
      <div className="mt-6 px-[10px]">
        <AuthMascot />
        <h1 className="mt-5 font-['Pretendard'] text-[22px] font-bold leading-[1.32] text-black">
          추천인 코드를 입력하고
          <br />
          <span className="text-primary-purple-01">즉시 1000 포인트</span>를 받아가세요 !
        </h1>
        <p className="mt-5 font-['Pretendard'] text-[16px] leading-[1.32] text-gray04">
          추천인 코드는 가입 이후에는 입력할 수 없어요.
        </p>
      </div>

      <div className="mt-10 px-[5px]">
        <AuthTextField
          value={code}
          onChange={(v) => {
            setCode(v);
            if (errorText) setErrorText('');
          }}
          placeholder="추천인 코드를 입력해주세요"
          error={!!errorText}
          errorText={errorText}
        />
      </div>
    </AuthOnboardingLayout>
  );
}
